<template>
    <n-layout-header bordered class="flex items-center justify-between px-4 h-14">
      <h3 class="text-lg font-semibold" style="margin-left: 20px;">CWS & IFOOD - CONTROLE DE BEACONS</h3>
      <div class="flex items-center gap-3" style="margin-right: 20px;">
        <n-switch v-model:value="isDark" size="small" @update:value="toggleTheme">
          <template #checked>🌙</template>
          <template #unchecked>☀️</template>
        </n-switch>
      </div>
    </n-layout-header>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { useOsTheme, darkTheme } from 'naive-ui'
  import { useThemeStore } from './themeStore'
  
  const themeStore = useThemeStore()
  const isDark = ref(themeStore.isDark)
  
  function toggleTheme() {
    themeStore.toggleTheme()
  }
  </script>
  
  <style scoped>
  .flex {
    display: flex;
  }
  .items-center {
    align-items: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  </style>
  